<template>
	<div>
		<el-divider>推荐位管理</el-divider>
		<el-button type="warning" size="mini" icon="el-icon-edit" @click="addDocumentLabel('')">添加推荐位</el-button>
		<el-button-group>
			<el-button type="primary" size="mini" icon="el-icon-select" @click="selectAll">全选</el-button>
			<el-button type="warning" size="mini" icon="el-icon-select" @click="selectDiff">反选</el-button>
		</el-button-group>
		<el-dropdown trigger="click">
			<el-button type="primary" icon="el-icon-setting" size="mini">
				筛选
				<i class="el-icon-arrow-down el-icon--right"></i>
			</el-button>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item v-for="(items, index) in filtrateList" :key="index">
					<el-dropdown trigger="hover" placement="right-start" @command="seleCommand">
						<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item
								icon="el-icon-caret-right"
								v-for="(item, key) in items.seconds"
								:key="key"
								:command="{ indexa: index, indexb: key, param: items.paramValue, paramval: item.val }"
								:class="item.checked ? 'color-blue' : ''"
							>
								{{ item.label }}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteDlabel">删除</el-button>
		<el-button type="warning" size="mini" icon="el-icon-refresh" @click="getDocumentLabelList()">刷新</el-button>
		<el-table
			:data="documentLabelList"
			style="width: 100%;margin-bottom: 20px;"
			row-key="dlid"
			:stripe="true"
			:default-sort="{ prop: 'ctime', order: 'ascending' }"
			@sort-change="sortChange"
			@selection-change="selectChange"
			tooltip-effect="dark"
			ref="multipleTable"
		>
			<el-table-column type="selection" width="55"></el-table-column>
			<el-table-column prop="dlid" label="序号" width="80" sortable></el-table-column>
			<el-table-column prop="mid" label="所属模型">
				<template slot-scope="scope">
					{{mlist[scope.row.mid].modelname}}
				</template>
			</el-table-column>
			<el-table-column prop="labelname" label="推荐位名称"></el-table-column>
			<el-table-column label="操作" width="200">
				<template slot-scope="scope">
					<el-button type="warning" size="mini" @click="addDocumentLabel(scope.row)">修改</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="thispage"
				:page-sizes="pageSizes"
				:page-size="pagesize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			></el-pagination>
		</div>
		<el-dialog title="添加推荐位" :visible.sync="dialogVisible" width="80%" :close-on-click-modal="false">
			<el-form class="text-left" ref="attrForm" :rules="rules" :model="dlabelScope">
				<el-form-item label="推荐位名称" :label-width="formLabelWidth" prop="labelname">
					<el-input v-model="dlabelScope.labelname" autocomplete="off" placeholder="请输入推荐位名称,2-50个字符"></el-input>
				</el-form-item>
				<el-form-item label="所属模型" :label-width="formLabelWidth">
					<el-select v-model="dlabelScope.mid" placeholder="请选择模型">
						<el-option v-for="item in mlist" :key="item.mid" :label="item.modelname" :value="item.mid"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitRuleForm('attrForm')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: '',
	data() {
		return {
			documentLabelList: [],
			mlist: [],
			selectedLabelIds: [],
			dialogVisible: false,
			dlabelScope: {
				mid: '', //所属模型id
				labelname: '' //推荐位名
			},
			rules: {
				labelname: [{ required: true, message: '请输入推荐位名称', trigger: 'blur' }, { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }],
				mid: [{ required: true, message: '请选择所属模型', trigger: 'blur' }]
			},
			formLabelWidth: '120px',
			filtrateList: [
				{
					label: '所属模型',
					paramValue: 'mid',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						}
					]
				}
			],
			selectParams:[],
			thispage: 1,
			total: 0,
			pagesize: 10, //每页显示条数
			pageSizes: [10, 15, 20, 30], //每页显示个数选择器
			sort_param: 'dlid', //排序字段
			sort_type: 'desc', //排序方式ascending = asc;descending = desc,'' = asc;
		};
	},
	mounted() {
		this.mid = this.$route.query.mid;
		this.modelname = this.$route.query.modelname;
		console.log(this.mid);
		this.getDocumentLabelList(1);
	},
	methods: {
		//每页分页条数修改
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			this.pagesize = val;
			this.getSeoList();
		},
		//当前页码翻页
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.thispage = val;
			this.getSeoList();
		},
		getDocumentLabelList(firstLoad = 0) {
			console.log(firstLoad);
			let separ = [];
			for (let i in this.selectParams) {
				console.log(i, this.selectParams[i]);
				separ.push({ param: i, paramVal: this.selectParams[i] });
			}
			this.$axios({
				url: this.HOST + '/admin.document/getDocumentLabelList',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					thispage:this.thispage,
					pagesize:this.pagesize,
					sort_param: this.sort_param,
					sort_type: this.sort_type,
					selectParams:separ,
					firstLoad: firstLoad,
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.documentLabelList = res.data.data;
						this.total = res.data.total;
						if(firstLoad){
							this.mlist = res.data.mlist;
							// 加入筛选条件
							for (let i in res.data.mlist) {
								this.filtrateList[0].seconds.push({
									val: res.data.mlist[i].mid,
									label: res.data.mlist[i].modelname
								});
							}
						}
					}
				})
				.catch(err => {});
		},
		selectChange(selection) {
			let arr = [];
			for (let i in selection) {
				arr.push(selection[i].dlid);
			}
			this.selectedLabelIds = arr;
			console.log(this.selectedLabelIds);
		},
		seleCommand(command) {
			console.log('sele:', command);
			this.selectParams[command.param] = command.paramval;
			this.filtrateList[command.indexa].seconds.map(item => {
				this.$set(item, 'checked', false);
			});
			this.filtrateList[command.indexa].seconds[command.indexb].checked = true;
			console.log(this.selectParams);
			this.getDocumentLabelList();
		},
		// 全选
		selectAll() {
			this.documentLabelList.map(item => {
				this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
			});
			// this.selectedLabelIds = this.docIds;
		},
		// 反选
		selectDiff() {
			let diff = [];
			this.documentLabelList.map(item => {
				if (this.selectedLabelIds.indexOf(item.dlid) != -1) {
					this.$refs.multipleTable.toggleRowSelection(item, false); //切换该子节点选中状态
				} else {
					diff.push(item.dlid);
					this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
				}
			});
			this.selectedLabelIds = diff;
			console.log(this.selectedLabelIds);
		},
		// 操作
		// 排序
		sortChange({ column, prop, order }) {
			console.log(column, prop, order);
			this.sort_param = prop;
			this.sort_type = order == 'descending' ? 'desc' : 'asc';
			this.getDocumentLabelList();
		},
		// 删除
		deleteDlabel() {
			if (!this.selectedLabelIds.length) {
				this.$message.error('尚未选中任何推荐位！');
				return false;
			}
			this.$confirm('是否要删除所选推荐位？一经删除不可恢复！')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.document/delDocumenLabel',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							dlabelIds: this.selectedLabelIds
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.$message.success(res.data.msg);
								this.getDocumentLabelList();
							}
						})
						.catch(err => {});
				})
				.catch(() => {});
		},
		addDocumentLabel(scope) {
			if (!scope) {
				this.dlabelScope = {
					mid: '',
					labelname: '', //推荐位名
				};
			} else {
				console.log(scope);
				this.dlabelScope = JSON.parse(JSON.stringify(scope));
			}
			this.dialogVisible = true;
		},
		submitRuleForm(formname) {
			this.$refs[formname].validate((valid, attr) => {
				if (valid) {
					this.addSubmit();
				} else {
					console.log('error submit!!', attr);
					return false;
				}
			});
		},
		addSubmit() {
			this.$confirm('确定提交？')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.document/addDocumentLabel',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							dlabel: this.dlabelScope
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.dialogVisible = false;
								this.$message.success(res.data.msg);
								this.thispage = 1;
								this.getDocumentLabelList();
							}
						})
						.catch(err => {});
				})
				.catch(() => {
					console.log('取消');
				});
		}
	}
};
</script>
<style>
.el-button + .el-button-group {
	margin-left: 10px;
	/* margin-right: 10px; */
}
.el-table__body-wrapper tbody {
	user-select: none;
}
.el-dialog {
	margin-top: 10vh !important;
}
</style>
